import { getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const FCM_SERVICE_WORKER_PATH = "/firebase-messaging-sw.js";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "AIzaSyDvmY-PO30d0BrJDUziiAPjlUJpC9nZwm4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "spos-369018.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "spos-369018",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "spos-369018.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "821135690153",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "1:821135690153:web:411f3ff8acbddbdf745cb8",
};

const resolveVapidKey = (): string | null => {
  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  return vapidKey && vapidKey.trim().length > 0 ? vapidKey : null;
};

/**
 * Returns whether the current browser environment supports Firebase web push.
 */
export const isFirebasePushSupported = async (): Promise<boolean> => {
  if (typeof window === "undefined") {
    return false;
  }

  if (!window.isSecureContext || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false;
  }

  return isSupported();
};

/**
 * Registers (or reuses) the messaging service worker and returns an FCM token.
 */
export const registerFirebasePushToken = async (): Promise<string | null> => {
  const supportsPush = await isFirebasePushSupported();

  if (!supportsPush) {
    return null;
  }

  const vapidKey = resolveVapidKey();

  if (!vapidKey) {
    throw new Error("Missing REACT_APP_FIREBASE_VAPID_KEY for push registration");
  }

  const app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);
  const registration = await navigator.serviceWorker.register(FCM_SERVICE_WORKER_PATH);
  const messaging = getMessaging(app);

  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: registration,
  });

  return token || null;
};
